import { render } from "./LiderVKadre.vue?vue&type=template&id=66af602a"
import script from "./LiderVKadre.vue?vue&type=script&lang=js"
export * from "./LiderVKadre.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__